// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__VHCMM","fadeOutSurvey":"styles_fadeOutSurvey__fZM0c","fadeOut":"styles_fadeOut__nSyQZ"};